import { CDN_URL, FLAG_CDN_URL } from "./consts";
import {
  isMobile,
  isTablet,
  isDesktop,
  browserName,
  osName,
  osVersion,
} from "react-device-detect";

export const get_media_url = (path) => {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${CDN_URL}/${path}`;
};

export const get_flagcdn_url = (iso) => {
  if (iso) return `${FLAG_CDN_URL}/${iso.toLowerCase()}.png`;
  return null;
};

export function formatDate(isoString) {
  const date = new Date(isoString);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month}, ${year}`;
}

export function getMonth(isoString) {
  const date = new Date(isoString);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = months[date.getMonth()];

  return `${month}`;
}

export function getDate(isoString) {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}`;
}

export function getDeviceDetails() {
  let deviceType = "Unknown";
  let osModel = "Unknown";
  let osVersionDetail = osVersion || "Unknown";

  if (isMobile) {
    deviceType = "Mobile";
  } else if (isTablet) {
    deviceType = "Tablet";
  } else if (isDesktop) {
    deviceType = "Desktop";
  }

  const userAgent = navigator.userAgent;

  if (/iPhone/i.test(userAgent)) {
    osModel = "iPhone";
  } else if (/iPad/i.test(userAgent)) {
    osModel = "iPad";
  } else if (/iPod/i.test(userAgent)) {
    osModel = "iPod";
  }

  if (/Android/i.test(userAgent)) {
    const modelMatch = userAgent.match(/; ([^;]+) Build/i);
    osModel = modelMatch ? modelMatch[1].trim() : "Unknown Android Device";
  }

  if (/Macintosh/i.test(userAgent) || /Mac/i.test(navigator.platform)) {
    osModel = "Macintosh";
  } else if (/Windows/i.test(navigator.platform)) {
    osModel = "Windows PC";
  } else if (/Linux/i.test(navigator.platform)) {
    osModel = "Linux PC";
  }

  return {
    osType: osName || "Unknown",
    osVersion: osVersionDetail,
    osModel,
    deviceType,
    browser: browserName || "Unknown",
  };
}

export const encodeId = (id) => btoa(id);
// export const decodeId = (id) => atob(id);

export const decodeId = (id) => {
  if (!isNaN(id)) {
    return id;
  }
  return atob(id);
};

